/**
 * @generated SignedSource<<3882ff276c0d0ce4632f11cfbe95c24b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskModalCategory_viewer$data = {
  readonly zendeskSupport: {
    readonly sections: ReadonlyArray<{
      readonly articles: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly title: string | null;
      } | null> | null;
      readonly displayName: string | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskModalCategory_viewer";
};
export type GetHelpZendeskModalCategory_viewer$key = {
  readonly " $data"?: GetHelpZendeskModalCategory_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskModalCategory_viewer">;
};

import GetHelpZendeskModalCategoryRefetchQuery_graphql from './GetHelpZendeskModalCategoryRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isSeller",
  "variableName": "isSeller"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "categoryId"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": GetHelpZendeskModalCategoryRefetchQuery_graphql
    }
  },
  "name": "GetHelpZendeskModalCategory_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskSupport",
      "kind": "LinkedField",
      "name": "zendeskSupport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "categoryId",
              "variableName": "categoryId"
            }
          ],
          "concreteType": "ZendeskSupportCategorySections",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                (v0/*: any*/)
              ],
              "concreteType": "ZendeskArticle",
              "kind": "LinkedField",
              "name": "articles",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "d97103bb111f2bf70605fa9fa5f97a13";

export default node;
